/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable import/no-duplicates */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import { format, parse } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useListarEmpreendimentosAdmin } from "services/api/Admin_Empreendimentos/empreendimentos";
import { AuthState } from "../../../../store/ducks/auth/types";
import * as Styles from "../../styles";
import MaterialUI from "../../../../material-UI";
import * as SVGIcons from "../../../../assets/iconsSVG";
import { useAtualizarTarefaLead } from "../../../../services/api/Mobile_Tarefas_Leads/atualizar_tarefa_lead";
import { useListarEmpreendimentos2 } from "../../../../services/api";

interface DataTask {
  idTarefaLead: string | null;
  titulo: string | null;
  codigoSequencial: string | null;
  tipoTarefa: string | null;
  idEmpreendimento: string | null;
  empreendimento: string | null;
  idLead: string | null;
  idLeadCorretor: string | null;
  nomeLead: string | null;
  telefonePrincipal: string | null;
  emailPrincipal: string | null;
  idTipoTarefa: string | null;
  descricao: string | null;
  dataHoraProgramadaRealizacaoTarefa: string | null;
  dataHoraConclusaoTarefa: string | null;
  codigoStatusTarefa: number | any;
  descricaoStatusTarefa: string | null;
  descricaoEtapaFunilLead: string | null;
  urlAnexo: string | null;
  tipoResultadoTarefa: string | null;
  observacao: string | null;
  tarefaInseridaOutlook: string | null;
  idTipoResultadoTarefa: string | null;
  tarefaLeadRegionalSul: string | null;
  presencaEspecialista: string | null;
  tipoDeAgendamentoVisita: string | null;
  idEmpreendimentoRegionalSul: string | null;
  empreendimentoRegionalSul: string | null;
  descricaoLocalRegionalSul: string | null;
  idEtapaFunilLead: string | null;
  idCorretor: string | null;
  nomeCorretor: string | null;
  idCorretorAtendimento: string | null;
  nomeCorretorAtendimento: string | null;
}

interface Props {
  closeModal: () => void;
  idLeadCorretor: string | any;
  idLead: string | any;
  refetch: () => void;
  dataTask: DataTask | null;
}

interface SelectProps {
  id: string | null;
  nome: string | null;
}

interface SelectPropsCustom {
  id: string | null;
  nome: string | null;
  codigo: string | null;
}

interface FileUploadProps {
  nome: string | null;
  anexoBase64: string | null;
}

const EditTaskV2: React.FC<Props> = (props) => {
  const { codigoCargo2013, codigoRegional365 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const isSul = codigoRegional365 === "2";
  const [lead, setLead] = useState<SelectProps | null>(null);
  const [tipoTarefa, setTipoTarefa] = useState<SelectProps | null>(null);
  const [titulo, setTitulo] = useState<string>("");
  const [empreendimento, setEmpreendimento] = useState<SelectProps | null>(
    null
  );
  const [descricao, setDescricao] = useState<string>("");
  const [data, setData] = useState<any>(isSul ? new Date() : null);
  const [hora, setHora] = useState<any>(isSul ? new Date() : null);
  const [produtoSul, setProdutoSul] = useState<SelectProps | null>(null);
  const { data: dataEmpreendimentoSul, refetch: refetchEmpreendimentosSul } =
    useListarEmpreendimentosAdmin();

  const { data: dataEmpreendimento2, refetch: refetchEmpreedimentos2 } =
    useListarEmpreendimentos2();

  useEffect(() => {
    refetchEmpreedimentos2();
    refetchEmpreendimentosSul();
  }, []);

  useEffect(() => {
    if (props?.dataTask) {
      setLead({
        id: props?.dataTask?.idLead,
        nome: props?.dataTask?.nomeLead,
      });
      setTipoTarefa({
        id: props?.dataTask?.idTipoTarefa,
        nome: props?.dataTask?.tipoTarefa,
      });
      setTitulo(props?.dataTask?.titulo ? props?.dataTask?.titulo : "");
      setDescricao(
        props?.dataTask?.descricao ? props?.dataTask?.descricao : ""
      );
      setData(
        props?.dataTask?.dataHoraProgramadaRealizacaoTarefa
          ? parse(
              props?.dataTask?.dataHoraProgramadaRealizacaoTarefa,
              "dd/MM/yyyy HH:mm",
              new Date()
            )
          : isSul ? new Date() : null
      );
      setHora(
        props?.dataTask?.dataHoraProgramadaRealizacaoTarefa
          ? parse(
              props?.dataTask?.dataHoraProgramadaRealizacaoTarefa,
              "dd/MM/yyyy HH:mm",
              new Date()
            )
          : isSul ? new Date() : null
      );
      setEmpreendimento(
        props?.dataTask?.idEmpreendimento
          ? {
              id: props?.dataTask?.idEmpreendimento,
              nome: props?.dataTask?.empreendimento,
            }
          : null
      );
      setProdutoSul(
        props?.dataTask?.idEmpreendimentoRegionalSul
          ? {
              id: props?.dataTask?.idEmpreendimentoRegionalSul,
              nome: props?.dataTask?.empreendimentoRegionalSul,
            }
          : null
      );
    }
  }, [props?.dataTask]);

  const params = {
    titulo,
    idTipoTarefa: tipoTarefa?.id ? tipoTarefa?.id : null,
    idEmpreendimento: !isSul ? empreendimento?.id ?? null : null,
    idEmpreendimentoRegionalSul: isSul ? produtoSul?.id ?? null : null,
    observacoes: descricao,
    dataProgramadaRealizacaoTarefa: !isNaN(Date.parse(data))
      ? format(data, "yyyy-MM-dd")
      : "",
    horaProgramadaRealizacaoTarefa: !isNaN(Date.parse(hora))
      ? format(hora, "HH:mm:ss")
      : "",
  };

  const { mutate, isLoading, isSuccess } = useAtualizarTarefaLead({
    idTarefaLead: props?.dataTask?.idTarefaLead
      ? props?.dataTask?.idTarefaLead
      : "",
    body: params,
  });

  useEffect(() => {
    if (isSuccess) {
      props?.closeModal();
      props?.refetch();
    }
  }, [isSuccess]);

  return (
    <Styles.DialogHeader
      style={{
        display: "flex",
        flex: 1,
        width: "100%",
        flexDirection: "column",
      }}
    >
      <Styles.ScrollContent maxHeight={375}>
        <Styles.RowGap>
          <Styles.Column>
            <Styles.LabelText>Lead</Styles.LabelText>
            <Styles.Autocomplete
              disabled
              id="combo-box-demo"
              defaultValue={{
                nome: "Selecione um tipo de atendimento",
                id: "1",
              }}
              fullWidth
              options={[]}
              value={lead}
              renderInput={(params: any) => (
                <>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Resultado *"
                    required
                    fullWidth
                  />
                </>
              )}
              getOptionSelected={(option: any) => option?.nome}
              getOptionLabel={(option: any) => option?.nome || ""}
              // @ts-ignore
              onChange={(
                event: any,
                newValue: {
                  id: string | null;
                  nome: string | null;
                } | null
              ) => {
                setLead(newValue);
              }}
            />
          </Styles.Column>
        </Styles.RowGap>
        <Styles.RowGap>
          <Styles.Column>
            <Styles.LabelText>Tipo da tarefa</Styles.LabelText>
            <Styles.Autocomplete
              disabled={false}
              id="combo-box-demo"
              defaultValue={{
                nome: "Selecione um tipo de atendimento",
                id: "1",
              }}
              fullWidth
              options={[]}
              value={tipoTarefa}
              renderInput={(params: any) => (
                <>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Resultado *"
                    required
                    fullWidth
                  />
                </>
              )}
              getOptionSelected={(option: any) => option?.nome}
              getOptionLabel={(option: any) => option?.nome || ""}
              // @ts-ignore
              onChange={(
                event: any,
                newValue: {
                  id: string | null;
                  nome: string | null;
                } | null
              ) => {
                setTipoTarefa(newValue);
              }}
            />
          </Styles.Column>
        </Styles.RowGap>
        <Styles.RowGap>
          <Styles.Column>
            <Styles.LabelText>Titulo</Styles.LabelText>
            <Styles.TextField
              size="small"
              InputLabelProps={{ shrink: false }}
              variant="outlined"
              label="Titulo"
              fullWidth
              onChange={(e: any) => setTitulo(e.target.value)}
              value={titulo}
            />
          </Styles.Column>
        </Styles.RowGap>
        {props?.dataTask?.tipoTarefa === "Agendamento de Visita" && !isSul ? (
          <Styles.RowGap>
            <Styles.Column>
              <Styles.LabelText>Produto</Styles.LabelText>
              <Styles.Autocomplete
                id="combo-box-demo"
                fullWidth
                options={
                  dataEmpreendimento2
                    ? dataEmpreendimento2?.data?.map((item: any) => ({
                        id: item?.id,
                        nome: item?.nome,
                      }))
                    : []
                }
                value={empreendimento}
                renderInput={(params: any) => (
                  <>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Resultado *"
                      required
                      fullWidth
                    />
                  </>
                )}
                getOptionSelected={(option: any) => option?.nome}
                getOptionLabel={(option: any) => option?.nome || ""}
                // @ts-ignore
                onChange={(
                  event: any,
                  newValue: {
                    id: string | null;
                    nome: string | null;
                  } | null
                ) => {
                  setEmpreendimento(newValue);
                }}
              />
            </Styles.Column>
          </Styles.RowGap>
        ) : null}

        {props?.dataTask?.tipoTarefa === "Agendamento de Visita" && isSul ? (
          <Styles.RowGap>
            <Styles.Column>
              <Styles.LabelText>
                Local <p>{" *"}</p>
              </Styles.LabelText>
              <Styles.Autocomplete
                id="combo-box-demo"
                defaultValue={{
                  nome: "Selecione um tipo da tarefa",
                  id: "1",
                }}
                fullWidth
                options={
                  dataEmpreendimentoSul
                    ? dataEmpreendimentoSul?.data?.map((item: any) => ({
                        id: item?.idEmpreendimento,
                        nome: item?.nome,
                      }))
                    : []
                }
                value={produtoSul}
                renderInput={(params: any) => (
                  <>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Tipo da tarefa"
                      required
                      fullWidth
                    />
                  </>
                )}
                getOptionSelected={(option: any) => option?.nome}
                getOptionLabel={(option: any) => option?.nome || ""}
                // @ts-ignore
                onChange={(event: any, newValue: any) => {
                  setProdutoSul(newValue);
                }}
              />
            </Styles.Column>
          </Styles.RowGap>
        ) : null}

        <Styles.RowGap>
          <Styles.Column>
            <Styles.LabelText>Data</Styles.LabelText>
            <Styles.LocalizationProvider
              locale={ptBR}
              dateAdapter={MaterialUI.AdapterDateFns}
            >
              <Styles.DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={data}
                components={{
                  OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) => setData(newValue)}
                renderInput={(params: any) => (
                  <>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Data *"
                      fullWidth
                    />
                  </>
                )}
              />
            </Styles.LocalizationProvider>
          </Styles.Column>
          <Styles.Column>
            <Styles.LabelText>Hora</Styles.LabelText>
            <Styles.LocalizationProvider
              locale={ptBR}
              dateAdapter={MaterialUI.AdapterDateFns}
            >
              <Styles.TimePicker
                inputFormat="HH:mm"
                value={hora}
                components={{
                  OpenPickerIcon: SVGIcons.ClockIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) => setHora(newValue)}
                renderInput={(params: any) => (
                  <>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Data *"
                      fullWidth
                    />
                  </>
                )}
              />
            </Styles.LocalizationProvider>
          </Styles.Column>
        </Styles.RowGap>
        <Styles.RowGap>
          <Styles.MultLineField>
            <Styles.LabelText>Descrição</Styles.LabelText>
            <Styles.TextField
              onChange={(e: any) => setDescricao(e.target.value)}
              label="Multiline"
              variant="outlined"
              fullWidth
              multiline
              minRows={3}
              value={descricao}
              inputProps={{ maxLength: 4000 }}
            />
            <Styles.CountText>{descricao.length}/4000</Styles.CountText>
          </Styles.MultLineField>
        </Styles.RowGap>
      </Styles.ScrollContent>
      <Styles.FooterDialog>
        <Styles.Button
          style={{ width: "100%" }}
          variant="outlined"
          onClick={() => {
            props.closeModal();
          }}
        >
          Fechar
        </Styles.Button>
        {isCorretor ? (
          <Styles.SaveButton
            onClick={() => mutate()}
            style={{
              width: "100%",
              background: "#4a76fb",
              boxShadow: "none",
              color: "#fff !important",
            }}
          >
            {isLoading ? <BeatLoader color="#fff" size={10} /> : "Atualizar"}
          </Styles.SaveButton>
        ) : null}
      </Styles.FooterDialog>
    </Styles.DialogHeader>
  );
};

export default EditTaskV2;
